import { differenceInCalendarDays } from 'date-fns';
import { date } from '@eti/utils';
import { useDateFormat } from '@eti/providers';
import { Fragment } from 'react';
import type { TripSegment } from '../../../../../../widgets/trip-itinerary/models';
import ItineraryChangeOfDate from './ItineraryChangeOfDate';
import ItineraryTechnicalStop from './ItineraryTechnicalStop';

interface ItineraryTripSegmentEventsProps {
  originalArrivalDate: string | null;
  segment: TripSegment;
}

const ItineraryTripSegmentEvents = ({
  originalArrivalDate,
  segment,
}: ItineraryTripSegmentEventsProps) => {
  const { weekday } = useDateFormat();

  return (
    <>
      {segment.technicalStops.map((technicalStop, index) => {
        const previousTechnicalStop = segment.technicalStops[index - 1];
        const nextTechnicalStop = segment.technicalStops[index + 1];

        const previousDeparture = previousTechnicalStop?.arrivalAt ?? segment.departuredAt;
        const previousDepartureDifferenceInDays = differenceInCalendarDays(
          new Date(previousDeparture),
          new Date(technicalStop.departureAt),
        );

        const nextDeparture = nextTechnicalStop?.departureAt ?? segment.arrivedAt;
        const nextDepartureDifferenceInDays = differenceInCalendarDays(
          new Date(nextDeparture),
          new Date(technicalStop.departureAt),
        );

        const isLastIteration = index < segment.technicalStops.length - 1;

        return (
          <Fragment key={`${segment.segmentId}-${index}`}>
            {previousDepartureDifferenceInDays > 0 && (
              <ItineraryChangeOfDate
                arrivalDate={date.format(previousDeparture, weekday)}
                durationInDays={previousDepartureDifferenceInDays}
                isDashed
                isDisplayedFirst
                originalArrivalDate={
                  isLastIteration && nextDepartureDifferenceInDays <= 0 ? originalArrivalDate : null
                }
              />
            )}
            <ItineraryTechnicalStop
              isDisplayedFirst={previousDepartureDifferenceInDays <= 0 && !previousTechnicalStop}
              isDisplayedLast={nextDepartureDifferenceInDays <= 0 && !nextTechnicalStop}
              technicalStop={technicalStop}
            />
            {nextDepartureDifferenceInDays > 0 && (
              <ItineraryChangeOfDate
                arrivalDate={date.format(nextDeparture, weekday)}
                durationInDays={nextDepartureDifferenceInDays}
                isDashed
                isDisplayedLast={!nextTechnicalStop}
                originalArrivalDate={isLastIteration ? originalArrivalDate : null}
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default ItineraryTripSegmentEvents;
